import stars from "@/assets/images/stars-4.8-green.svg?react";
import { clsxm } from "@/utils/clsxm";

interface IProps {
  t10_2?: boolean;
}

const Reviews = ({ t10_2 }: IProps) => (
  <div
    className={clsxm(
      "flex gap-x-4 gap-y-2 items-center text-xs sm:text-sm flex-col text-white",
      t10_2 && "flex-row gap-x-2 flex-wrap justify-center mx-2 lg:ml-auto"
    )}
  >
    <p className="font-semibold leading-[100%]">Excellent 4.8</p>
    <div>
      <img
        src={stars as unknown as string}
        className="w-full h-full object-contain"
        alt="Trustpilot stars"
      />
    </div>
    <p className="leading-[100%] text-center">
      50,000+
      <span className="capitalize font-normal"> happy customers</span>
    </p>
  </div>
);

export { Reviews };
